import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from '../../Panel/Panel';
import { List, ListItem, ListItemText } from '../../material-ui/List';
import { EmployeeItem } from './../EmployeeItem/EmployeeItem';
import { getTranslateText } from '../../../service/utils';
import { useStyles } from './useStyles';

export const EmployersList = memo(({ data, title }) => {
    const classes = useStyles();
    const { t: translate } = useTranslation();

    return (
        <Panel title={title} className={classes.panel}>
            <List>
                {data && data.length > 0 ? (
                    data.map((emp) => (
                        <EmployeeItem
                            key={emp.crewId}
                            fullName={getTranslateText('fullName', emp)}
                            staffTree={getTranslateText('staffTree', emp)}
                            chair={getTranslateText('chair', emp)}
                            phone={emp.phone}
                            email={emp.email}
                            url={emp.url}
                        />
                    ))
                ) : (
                    <ListItem disabled={true}>
                        <ListItemText primary={translate('labels.noCrewInfo')} />
                    </ListItem>
                )}
            </List>
        </Panel>
    );
});
